import React from "react";
import { useState } from "react";
import logo from "..//assets/logo.png";
import { CiUser } from "react-icons/ci";
import icon from "..//assets/icon.png";
import icon1 from "..//assets/icon1.png";
import icon2 from "..//assets/icon2.png";
import icon3 from "..//assets/icon3.png";
import face from "..//assets/face.png";
import twit from "..//assets/twit.png";
import insta from "..//assets/insta.png";
import { HiMenu, HiX } from "react-icons/hi";
import Image from "..//assets/feature.png";
import BannerImage from "..//assets/backgrpungimage.png"; // Replace with your product image path
import ModelImage from "..//assets/feather.png"; // Replace with your model image path
import Logo from "..//assets/logo.png";
import flower from "..//assets/Product_2.png";
import I from "..//assets/icon11.png";
import I1 from "..//assets/icon12.png";
import I2 from "..//assets/icon13.png";
import art from "..//assets/art.png";
import I3 from "..//assets/icon14.png";
import background from "..//assets/back.png";
import Ban from "..//assets/ban.png";
import product from "..//assets/product1.png";
import product1 from "..//assets/product2.png";
import product2 from "..//assets/product3.png";
import product3 from "..//assets/product4.png";
import product4 from "..//assets/product5.png";
import product5 from "..//assets/product6.png";
import product6 from "..//assets/product7.png";
import product7 from "..//assets/product8.png";
import ProductImageGallery from "./ProductImageGallery";
import ProductInfo from "./ProductInfo";
import RecommendedProducts from "./RecommendedProducts";

import { useParams } from "react-router-dom";

function ProductDetails() {
    // import bannerImage from './assets/banner.jpg';  // Logo image path
    // import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

    return (
        <>
            <Header />
            <Banner />
            <ProductFeatures />
            <FeatureHighlights />
            <Nextsection />
            <FAQSection />
            <Footer />
            {/* <AnimatedBoxes />  */}
        </>
    );
}

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-1xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}
                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
            <div className="font-sans  top-0 left-0 right-0 flex justify-between py-3 px-6 bg-[#52B3A4] text-white text-sm font-semibold">
                <p>Purchase above ₹500</p>
                <p>Free Shipping</p>
                <p>20% off on Amazon</p>
                <p>50% off on purchase above ₹50</p>
            </div>
        </header>
    );
}
function Banner() {
    return (
        <div
            className=" lg:w-full  max-md:w-full md:w-full lg:h-screen max-md:h-screen md:h-[60vh] lg:bg-center lg:bg-no-repeat lg:bg-cover lg:object-fit-cover max-sm:w-full max-sm:h-[25vh]"
            style={{
                backgroundImage: `url(${BannerImage})`,
                backgroundSize: "cover", // Ensures the image covers the entire area
                backgroundPosition: "fit",
            }}
        >
            {/* Top Offer Bar */}
        </div>
    );
}
function ProductFeatures() {
    return (
        <div className="py-16 bg-white">
            <div className="max-w-5xl mx-auto text-center">
                {/* Title */}
                <h2 className="mb-8 text-3xl font-bold text-gray-900">
                    Sanitary Pads
                </h2>

                {/* Features Section */}
                <div className="flex flex-wrap items-center justify-center gap-8">
                    {/* Left Feature 1 */}
                    <div className="text-center sm:w-1/3 sm:text-right">
                        <h3 className="font-sans text-lg font-bold text-gray-1500">
                            High Absorption
                        </h3>
                        <p className="font-sans text-sm font-medium text-gray-600">
                            Pads are designed for high absorption even in high
                            Blood flow.
                        </p>
                    </div>

                    {/* Product Image */}
                    <div className="items-center flex-shrink-0 lg:w-64 lg:h-36 md:w-36 md:h-28">
                        <img
                            src={flower}
                            alt="Sanitary Pad"
                            className="h-64 w-72"
                        />
                    </div>

                    {/* Right Feature 1 */}
                    <div className="text-center sm:w-1/3 sm:text-left">
                        <h3 className="font-sans text-lg font-bold text-gray-1500">
                            Feathery soft
                        </h3>
                        <p className="font-sans text-sm font-medium text-gray-600">
                            This product was made with high quality microfiber
                            material.
                        </p>
                    </div>
                </div>

                {/* Bottom Features */}
                <div className="grid grid-cols-1 gap-6 mt-8 sm:grid-cols-2">
                    {/* Bottom Left */}
                    <div className="text-center">
                        <h3 className="font-sans text-lg font-bold text-gray-1500">
                            0% of leaks
                        </h3>
                        <p className="font-sans text-sm font-medium text-gray-600">
                            We give 100% assurance in 0% leak proof.
                        </p>
                    </div>

                    {/* Bottom Right */}
                    <div className="text-center">
                        <h3 className="font-sans text-lg font-bold text-gray-1500">
                            Long lasting Pads
                        </h3>
                        <p className="font-sans text-sm font-medium text-gray-600">
                            Longer pads for more number of hours.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

function FeatureHighlights() {
    return (
        <div
            className="py-24"
            style={{
                backgroundImage: `url(${background})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
            }}
        >
            <div className="max-w-6xl px-4 mx-auto sm:px-6 lg:px-8">
                {/* Features Section */}
                <div className="space-y-12">
                    {/* Feature 1 - Left-aligned */}
                    <div className="flex items-start space-x-4">
                        <div className="overflow-hidden bg-white rounded-full shadow-md">
                            <img
                                src={I}
                                alt="Rashes Free"
                                className="object-cover w-40 h-40" // Ensure image fits within the circle
                            />
                        </div>
                        <div>
                            <h3 className="font-sans text-xl font-bold text-gray-800">
                                Rashes Free
                            </h3>
                            <p className="font-sans font-normal text-gray-600">
                                Bestie's pads are designed to avoid unwanted
                                itching and rashes.
                            </p>
                        </div>
                    </div>

                    {/* Feature 2 - Right-aligned */}
                    <div className="flex flex-row-reverse items-start space-x-4">
                        <div className="overflow-hidden bg-white rounded-full shadow-md">
                            <img
                                src={I1}
                                alt="Chemical Free"
                                className="object-cover w-40 h-40" // Ensure image fits within the circle
                            />
                        </div>
                        <div>
                            <h3 className="font-sans text-xl font-bold text-gray-800">
                                Chemical Free
                            </h3>
                            <p className="font-sans font-normal text-gray-600">
                                You are always our priority; no harmful
                                chemicals are used.
                            </p>
                        </div>
                    </div>

                    {/* Feature 3 - Left-aligned */}
                    <div className="flex items-start space-x-4">
                        <div className="overflow-hidden bg-white rounded-full shadow-md">
                            <img
                                src={I2}
                                alt="Rashes Free"
                                className="object-cover w-40 h-40" // Ensure image fits within the circle
                            />
                        </div>
                        <div>
                            <h3 className="font-sans text-xl font-bold text-gray-800">
                                Feathery Soft
                            </h3>
                            <p className="font-sans font-normal text-gray-600">
                                These pads are made of ultra-thin soft material
                                for your comfort.
                            </p>
                        </div>
                    </div>

                    {/* Feature 2 - Right-aligned */}
                    <div className="flex flex-row-reverse items-start space-x-4">
                        <div className="overflow-hidden bg-white rounded-full shadow-md">
                            <img
                                src={I3}
                                alt="Chemical Free"
                                className="object-cover w-40 h-40" // Ensure image fits within the circle
                            />
                        </div>
                        <div>
                            <h3 className="font-sans text-xl font-bold text-gray-800">
                                Safe and Secure
                            </h3>
                            <br></br>
                            <p className="font-sans font-normal text-gray-600">
                                Over thousands of Indian women trust Bestie's
                                sanitary pads.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function Nextsection() {
    return (
        <section
            className="py-2 mb-0 lg:h-[80vh]"
            style={{
                backgroundImage: `url(${art})`, // Replace with the actual path of your background image
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
        >
            <div className="container flex flex-col items-center px-4 mx-auto lg:mt-10 lg:flex-row">
                {/* Left Side Image */}
                <div className="flex-1">
                    <img
                        src={Image} // Replace with your main image path
                        alt="Bestie Sanitary Pads"
                        className="w-full max-w-md mx-auto lg:max-w-none"
                    />
                </div>

                {/* Right Side Content */}
                <div className="flex-1 ">
                    <h2 className="mb-4 text-2xl font-bold text-green-800">
                        Why You Will Love It!
                    </h2>
                    <ul className="space-y-2 text-green-800">
                        <li>✅ Up to 0% leaks all night long</li>
                        <li>
                            ✅ Longer & wider back so you are covered from leaks
                            from all sides
                        </li>
                        <li>
                            ✅ Dual action gel that locks wetness and
                            neutralizes odor
                        </li>
                        <li>✅ 8 layers give comfort and feel light</li>
                    </ul>
                    <button className="px-6 py-2 mt-6 mb-4 text-white bg-green-900 rounded-md hover:bg-green-900">
                        Shop Now
                    </button>
                </div>
            </div>
        </section>
    );
}
function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "What Is Your Return Policy?",
            answer: "You can return items within 30 days of purchase.",
        },
        {
            question: "How Long Does Shipping Take?",
            answer: "Shipping typically takes 5-7 business days.",
        },
        {
            question: "Do You Offer International Shipping?",
            answer: "Yes, we ship to select countries worldwide.",
        },
        {
            question: "Can I Change My Order After Placing It?",
            answer: "You can change your order within one hour of placing it.",
        },
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="w-full py-16 bg-gray-50">
            {" "}
            {/* Full section wrapper with padding */}
            <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-8">
                {" "}
                {/* Container for equal left-right space */}
                <h2 className="font-sans text-3xl font-semibold tracking-tight text-center text-gray-900">
                    Frequently Asked Questions
                </h2>
                <br></br>
                {/* FAQ List */}
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="pb-4 border-b-2 border-gray-200 cursor-pointer"
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="font-sans text-lg font-semibold text-gray-700">
                                    {faq.question}
                                </h3>
                                <svg
                                    className={`w-6 h-6 transition-transform transform ${
                                        activeIndex === index
                                            ? "rotate-180"
                                            : ""
                                    }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                            {activeIndex === index && (
                                <p className="mt-2 text-gray-600">
                                    {faq.answer}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-4">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon}
                        alt="Free Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Free Shipping</h3>
                    <p className="font-sans font-normal ">
                        On all orders over ₹50
                    </p>
                </div>

                {/* Column 2 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon1}
                        alt="Secure Payment"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Secure Payment</h3>
                    <p className="font-sans font-normal ">
                        Guaranteed safe checkout
                    </p>
                </div>

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon2}
                        alt="Customer Support"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        24/7 Customer Support
                    </h3>
                    <p className="font-sans font-normal ">
                        We're here to help you
                    </p>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Easy Returns</h3>
                    <p className="font-sans font-normal ">
                        Hassle-free returns within 30 days
                    </p>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="Twitter" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Fab Dudes. All rights
                    reserved.
                </p>
            </div>
        </div>
    );
}

export default ProductDetails;
